<template>
  <div dir="rtl" class="modal fade" id="forgetpassword-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered" style="max-width: 500px">
      <div class="modal-content p-3">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title">
            {{ step === 1 ? "استعادة كلمة المرور" : "تأكيد الرمز وكلمة المرور الجديدة" }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- الصورة -->
          <div class="text-center mb-3">
            <img src="assets/img/pin.png" style="width: 140px" />
          </div>

          <!-- رسالة النجاح -->
          <p v-if="successMessage" class="text-center alert alert-success fw-bold">
            {{ successMessage }}
          </p>

          <p v-if="step === 1" class="text-center bg-light p-2 rounded fw-bold">
            أدخل رقم الهاتف لاستعادة كلمة المرور
          </p>
          <p v-else class="text-center bg-light p-2 rounded fw-bold">
            أدخل رمز التحقق وكلمة المرور الجديدة
          </p>

          <!-- خطوة إدخال رقم الهاتف -->
          <div v-if="step === 1">
            <div class="form-group mb-3">
              <label>رقم الهاتف</label>
              <input id="phoneOtp" type="tel" class="form-control" dir="ltr" />
            </div>

            <!-- اختيار وسيلة الارسال -->
            <div class="form-group mb-3">
              <label class="d-block fw-bold mb-1">طريقة الإرسال</label>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_sms"
                  value="sms"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_sms">رسالة نصية (SMS)</label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_whatsapp"
                  value="whatsapp"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_whatsapp">واتساب </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method_email"
                  value="email"
                  v-model="selectedMethod"
                />
                <label class="form-check-label" for="method_email"
                  >البريد الالكتروني</label
                >
              </div>
            </div>

            <small v-if="errorMessage" class="text-danger">{{ errorMessage }}</small>

            <button
              class="btn btn-success w-100"
              :disabled="isLoading"
              @click="sendPhone"
            >
              {{ isLoading ? "جاري الإرسال..." : "إرسال الرمز" }}
            </button>
          </div>

          <!-- خطوة إدخال OTP -->
          <div v-else>
            <div class="form-group mb-3">
              <label>رمز التحقق (OTP)</label>
              <input
                v-model="otp"
                type="text"
                class="form-control"
                placeholder="أدخل الرمز"
              />
            </div>

            <div class="form-group mb-3">
              <label>كلمة المرور الجديدة</label>
              <input
                v-model="newPassword"
                type="password"
                class="form-control"
                placeholder="********"
              />
            </div>

            <div class="form-group mb-3">
              <label>تأكيد كلمة المرور</label>
              <input
                v-model="confirmPassword"
                type="password"
                class="form-control"
                placeholder="********"
              />
            </div>

            <small v-if="errorMessage" class="text-danger d-block mb-2">{{
              errorMessage
            }}</small>

            <div class="d-flex gap-2">
              <button
                class="btn btn-secondary w-50"
                :disabled="isLoading"
                @click="goBack"
              >
                رجوع
              </button>
              <button
                class="btn btn-success w-50"
                :disabled="isLoading"
                @click="resetPassword"
              >
                {{ isLoading ? "جاري التحديث..." : "تحديث كلمة المرور" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";
var iti2;

export default {
  data() {
    return {
      step: 1,
      otp: "",
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      selectedMethod: "sms",
    };
  },
  mounted() {
    const modal = document.getElementById("forgetpassword-modal");
    const phone = document.getElementById("phoneOtp");

    modal.addEventListener("shown.bs.modal", () => {
      iti2 = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly",
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
  },
  methods: {
    goBack() {
      this.errorMessage = "";
      this.successMessage = "";
      this.step = 1;
      this.selectedMethod = "sms";
      this.$nextTick(() => {
        const phone = document.getElementById("phoneOtp");
        iti2 = intlTelInput(phone, {
          utilsScript: "assets/js/utils.js",
          initialCountry: "ly",
          separateDialCode: true,
          excludeCountries: ["il"],
        });
      });
    },

    async sendPhone() {
      this.errorMessage = "";
      this.successMessage = "";
      try {
        this.isLoading = true;
        const phoneNumber = iti2.getNumber();

        const payload = {
          phone: phoneNumber,
          country_code: "+" + iti2.getSelectedCountryData().dialCode,

          sms: this.selectedMethod === "sms" ? 1 : 0,
          whatsapp: this.selectedMethod === "whatsapp" ? 1 : 0,
          email: this.selectedMethod === "email" ? 1 : 0,
        };

        const res = await fetch(`${apiUrl}/forgot-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء الإرسال");
        }

        this.successMessage = `تم إرسال الرمز إلى رقمك`;
        this.step = 2;
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء الإرسال";
      } finally {
        this.isLoading = false;
      }
    },

    async resetPassword() {
      this.errorMessage = "";
      if (!this.otp) {
        this.errorMessage = "يرجى إدخال رمز التحقق";
        return;
      }
      if (!this.newPassword || this.newPassword.length < 6) {
        this.errorMessage = "كلمة المرور يجب أن تكون 6 أحرف على الأقل";
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = "كلمتا المرور غير متطابقتين";
        return;
      }

      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/reset-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            otp: this.otp,
            new_password: this.newPassword,
          }),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.message || "حدث خطأ أثناء التحديث");
        }

        // إغلاق المودال
        const modal = document.getElementById("forgetpassword-modal");
        const bsModal = bootstrap.Modal.getInstance(modal);
        if (bsModal) {
          bsModal.hide();
        }

        // إعادة تعيين البيانات
        this.step = 1;
        this.otp = this.newPassword = this.confirmPassword = "";
        this.successMessage = "";
        this.errorMessage = "";

        // عرض رسالة النجاح
        Swal.fire("تم التحديث", "تم تغيير كلمة المرور بنجاح", "success");
      } catch (err) {
        this.errorMessage = err.message || "حدث خطأ أثناء التحديث";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 12px;
}
.form-group label {
  font-weight: 700;
  margin-bottom: 8px;
}
.btn {
  padding: 10px;
  font-weight: bold;
}
</style>
